import { createAction } from 'redux-actions';
import {
  REQUEST_LOGIN_SUCCESS,
  REQUEST_LOGIN_FAILURE,
  LOGOUT_USER,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  PASSWORD_RESET_REQUEST_EMAIL_SUCCESS,
  PASSWORD_RESET_REQUEST_EMAIL_FAILURE,
  PASSWORD_RESET_VERIFY_TOKEN_SUCCESS,
  PASSWORD_RESET_VERIFY_TOKEN_FAILURE,
  SET_NEW_PASSWORD_SUCCESS,
  SET_NEW_PASSWORD_FAILURE,
  CHECK_EMAIL_SUCCESS,
  CHECK_EMAIL_FAILURE,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE
} from '../constants/actionTypes';

import * as Auth from '../api/authentication';
import { requestCurrentUser } from './users';
import { showSuccessSnackbar, showErrorSnackbar } from './snackbar';
import { setToken, removeToken } from '../helpers/localStorageCache';

const loginUserSuccess = createAction(REQUEST_LOGIN_SUCCESS);
const loginFailure = createAction(REQUEST_LOGIN_FAILURE);

export function requestLogin(loginData) {
  return dispatch => Auth.requestLogin(loginData)
    .then(({ data }) => {
      if(data.data.error_code != null)
        return data.data;
      setToken('jwtToken', data.data.access);
      setToken('refreshToken', data.data.refresh);
      // localStorage.setItem("selectedBrandId",null)
      dispatch(loginUserSuccess(data));
      return dispatch(requestCurrentUser());
    })
    .catch(error => dispatch(loginFailure(error?.response?.data?.errors?.error)));
}

const logoutUser = createAction(LOGOUT_USER);

export function logout() {
  return (dispatch) => {
    removeToken('jwtToken');
    removeToken('refreshToken');
    dispatch(logoutUser());
    window.location.href = '/';
  };
}

const changePasswordSuccess = createAction(CHANGE_PASSWORD_SUCCESS);
const changePasswordFailure = createAction(CHANGE_PASSWORD_FAILURE);

export function changePassword(passwordData) {
  return dispatch => Auth.changePassword(passwordData)
    .then(({ data }) => dispatch(changePasswordSuccess(data)))
    .catch(error => dispatch(changePasswordFailure(error?.response?.data?.errors?.error)));
}

const resetPasswordMailSuccess = createAction(PASSWORD_RESET_REQUEST_EMAIL_SUCCESS);
const resetPasswordMailFailure = createAction(PASSWORD_RESET_REQUEST_EMAIL_FAILURE);

export function resetPasswordMail(params) {
  return dispatch => Auth.getResetPasswordEmail(params)
    .then(({ data }) => {
      dispatch(resetPasswordMailSuccess(data));
      dispatch(showSuccessSnackbar('Reset password mail has been sent successfully'));
      return true;
    })
    .catch((error) => {
      dispatch(resetPasswordMailFailure(error));
      dispatch(showErrorSnackbar('Email has not been sent'));
      return false;
    });
}

const resetPasswordTokenVerifySuccess = createAction(PASSWORD_RESET_VERIFY_TOKEN_SUCCESS);
const resetPasswordTokenVerifyFailure = createAction(PASSWORD_RESET_VERIFY_TOKEN_FAILURE);

export function resetPasswordTokenVerify(params) {
  return dispatch => Auth.verifyResetPasswordToken(params)
    .then(({ data }) => {
      dispatch(resetPasswordTokenVerifySuccess(data));
      return true;
    })
    .catch((error) => {
      dispatch(resetPasswordTokenVerifyFailure(error));
      dispatch(showErrorSnackbar('Email has been expired please try again'));
      return false;
    });
}

const setNewPasswordSuccess = createAction(SET_NEW_PASSWORD_SUCCESS);
const setNewPasswordFailure = createAction(SET_NEW_PASSWORD_FAILURE);

export function setNewPassword(params) {
  return dispatch => Auth.confirmNewPassword(params)
    .then((res) => {
      dispatch(setNewPasswordSuccess(res.data));
      dispatch(showSuccessSnackbar('Password updated successfully'));
      return true;
    })
    .catch((error) => {
      dispatch(setNewPasswordFailure(error));
      dispatch(showErrorSnackbar('Password has not been updated'));
      return false;
    });
}

const checkEmailSuccess = createAction(CHECK_EMAIL_SUCCESS);
const checkEmailFailure = createAction(CHECK_EMAIL_FAILURE);

export function checkEmail(emailData) {
  return dispatch => Auth.checkEmail(emailData)
    .then(({ data }) => {
      dispatch(showSuccessSnackbar('Email retrieved successfully'));
      return dispatch(checkEmailSuccess(data));
    })
    .catch((error) => {
      dispatch(showErrorSnackbar('Invalid Email'));
      return dispatch(checkEmailFailure(error));
    });
}
const resetPasswordSuccess = createAction(RESET_PASSWORD_SUCCESS);
const resetPasswordFailure = createAction(RESET_PASSWORD_FAILURE);

export function resetPassword(emailData) {
  return dispatch => Auth.resetPassword(emailData)
    .then(({ data }) => {
      dispatch(showSuccessSnackbar('Password updated successfully'));
      return dispatch(resetPasswordSuccess(data));
    })
    .catch((error) => {
      dispatch(showErrorSnackbar('Password reset failed'));
      return dispatch(resetPasswordFailure(error));
    });
}

export function requestIpConfirm(loginData) {
  return dispatch => Auth.requestIpConfirm(loginData)
    .then(({ data }) => {
      dispatch(showSuccessSnackbar('Verification link has been sent. Please check your email.'));
      return;
    })
    .catch(error => dispatch(showErrorSnackbar('IP Confirmation Failed')));
}

export function requestCode(loginData) {
  return dispatch => Auth.requestCode(loginData)
    .then(({ data }) => {
      dispatch(showSuccessSnackbar('Please check your email for the code'));
      return data;
    })
    .catch(error => dispatch(showErrorSnackbar('Failed to sent code')));
}

export function requestAddDevice(loginData) {
  return dispatch => Auth.requestAddDevice(loginData)
    .then(({ data }) => {
      dispatch(showSuccessSnackbar('This Device has been added to your account'));
      return data;
    })
    .catch(error => dispatch(showErrorSnackbar('Code was invalid')));
  }
